import { executePost } from '@/services/lukita'

// A short-lived, single-use ticket that lets the import picker page ask lukita to finish one provider sign-in.
export const requestCloudImportTicket = async () => {
  const response = await executePost('/cloud_imports/tickets')
  const { ticket } = await response.json()
  if (typeof ticket !== 'string' || ticket.length === 0) {
    throw new Error('lukita answered with no cloud import ticket')
  }
  return ticket
}
